<template>
</template>
<script>
    import Axios from 'axios';

    export default {

        props: {
            id: {
                type: String,
                default: false
            },
            language: {
                type: String,
                required: true
            },
            categorie: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                loading: true,
            };
        },

        mounted() {
            this.countCounter();
        },
        methods: {
            countCounter() {
                this.loading = true;
                Axios.get(`/umbraco/mdmostread/counter/add?id=${this.id}&language=${this.language}&categorie=${this.categorie}`).then(response => {
                    this.entries = response.data.data;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                });

            }
        }
    }

</script>